import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { finalize } from 'rxjs';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-contact-us',
  imports: [CommonModule, FormsModule],
  templateUrl: './contact-us.html',
  styleUrl: './contact-us.css',
})
export class ContactUs {
  @ViewChild('contactForm') private contactForm?: NgForm;
  @ViewChild('subjectDropdown') private subjectDropdown?: ElementRef<HTMLElement>;

  private readonly mailerUrl = `${environment.apiBaseUrl}/mailer`;

  fullName: string = '';
  subject: string = '';
  email: string = '';
  projectSummary: string = '';
  isDropdownOpen: boolean = false;
  isSubmitting: boolean = false;
  successMessage: string = '';
  errorMessage: string = '';

  readonly subjects = [
    'Partnership Inquiry',
    'Venture Idea Submission',
    'Career Opportunities',
    'General Inquiry',
    'Other',
  ];

  readonly channels = [
    { label: 'Email', value: 'contact@tricoreholdings.pk' },
    // { label: 'Phone', value: '+92 300 555 0148' },
    // { label: 'Investor Desk', value: 'invest@tricoreholdings.com' },
    { label: 'Location', value: '13th floor, first capital tower, Lahore'},
  ];

  constructor(private readonly http: HttpClient) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.isDropdownOpen || !this.subjectDropdown) {
      return;
    }

    const target = event.target;

    if (target instanceof Node && !this.subjectDropdown.nativeElement.contains(target)) {
      this.isDropdownOpen = false;
    }
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectSubject(subj: string): void {
    this.subject = subj;
    this.isDropdownOpen = false;
  }

  submitForm(): void {
    if (this.isSubmitting) {
      return;
    }

    if (this.contactForm?.invalid) {
      this.errorMessage = 'Please correct the errors before submitting.';
      return;
    }

    this.successMessage = '';
    this.errorMessage = '';

    const fullName = this.fullName.trim();
    const subject = this.subject.trim();
    const email = this.email.trim();
    const projectSummary = this.projectSummary.trim();

    if (!fullName || !subject || !email || !projectSummary) {
      this.errorMessage = 'Please complete all fields before submitting.';
      return;
    }

    this.isSubmitting = true;

    this.http
      .post<{ message?: string }>(this.mailerUrl, {
        fullname: fullName,
        email: email,
        subject,
        message: projectSummary,
      })
      .pipe(finalize(() => (this.isSubmitting = false)))
      .subscribe({
        next: (response) => {
          this.successMessage = 'Response have been recieved we will get in touch with you shortly';
          this.contactForm?.resetForm({
            fullName: '',
            subject: '',
            email: '',
            projectSummary: '',
          });
          this.isDropdownOpen = false;
        },
        error: (error) => {
          this.errorMessage =
            error?.error?.error || 'We could not send your message right now. Please try again.';
        },
      });
  }
}
